import { makeStyles } from 'tss-react/mui';

const useStylesContentListContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  contentListContainer: {
    overflowY: 'scroll !important',
  },
  contentListContainerDefault: {
    overflowY: 'auto !important',
  },
}));

export default useStylesContentListContainer;
